// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__35a1X","disabled":"FileBtn_disabled__dnHD1","warn":"FileBtn_warn__32Ziz","fade":"FileBtn_fade__fKt9g"};